<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="display:block;top:0"></div>
    <div :style="{ 'z-index': (currentZIndex+1)}"
      id="rew19_shoppingCartModal" tabindex="-1" role="dialog" aria-labelledby="shoppingCartModal" aria-hidden="true" data-backdrop="static" data-keyboard="false" class="rew19_modal" style="display: block;">
      <div class="rew19_modal-dialog rew19_modal-dialog-centered" role="document">
        <div class="rew19_modal-content">
          <div class="rew19_modal-body">
            <div id="rew19_add-to-cart">
              <div class="cart-overlay">
                <div class="cart-confirm">
                  <div class="icons"><span class="icon-shopping-bag"></span></div>
                  <p class="text-confirm" v-html="message" style="text-align:center;max-width:255px"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message : {
      type: String,
      default: "신규 장바구니 담기 성공!"
    },
  },
  data() {
    return {
      currentZIndex : 2000,
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  methods :{

    /**
     * Local
     */
    initData : function(){
      let _this = this;
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/CartAdded.vue